module.exports = __webpack_public_path__ + "static/media/thumb-diarios.de0edf8a.png";